import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { Invitations } from '@/components/User/Invitations';
import { UserManagement } from '@/components/User/Management/UserManagement';
import { userRoleFilterValues } from '@/components/User/userRoleItems';
import { useUser } from '@/hooks/useUser';
import { searchParam } from '@/utils/router';
import { requiredSortingSearchParam } from '@/utils/tableSorting';

const usersSearchSchema = z.object({
  uPageSize: z.number().default(30).catch(30),
  uPageIndex: z.number().default(0).catch(0),
  uSearch: searchParam().optional(),
  uRole: z.enum(userRoleFilterValues).optional(),
  uSorting: requiredSortingSearchParam([{ id: 'name', desc: false }]),
});

export const Route = createFileRoute('/$organizationName/settings/_access/users')({
  component: SecuredUsersPage,
  validateSearch: usersSearchSchema,
});

function SecuredUsersPage() {
  return (
    <RequireEntitlements admins={['isSuperAdmin']}>
      <UsersPage />
    </RequireEntitlements>
  );
}

function UsersPage() {
  const { organizationDisplayName } = useUser();

  useEffect(() => {
    document.title = `${organizationDisplayName || 'Driver'} - Users`;
  }, [organizationDisplayName]);

  return (
    <SettingsPageLayout fullWidthWithPadding hideSeparator innerClassName="space-y-10">
      <Invitations />
      <UserManagement />
      <Outlet />
    </SettingsPageLayout>
  );
}
